/// <amd-module name="Artifacts/Conda/components/Logo" />
import * as CondaRes from "Artifacts/Conda/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-conda.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={CondaRes.Logo_Conda}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-conda/img/conda.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
